import React, { useEffect } from "react";
import {
  FaCheckCircle,
  FaExclamationCircle,
  FaInfoCircle,
  FaTimes,
} from "react-icons/fa";

const Toast = ({
  message,
  type = "info", // 'success', 'error', 'info', 'warning'
  duration = 5000, // Duration in milliseconds
  onClose,
}) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const getIcon = () => {
    switch (type) {
      case "success":
        return <FaCheckCircle className="h-6 w-6 text-green-500" />;
      case "error":
        return <FaExclamationCircle className="h-6 w-6 text-red-500" />;
      case "warning":
        return <FaExclamationCircle className="h-6 w-6 text-yellow-500" />;
      default:
        return <FaInfoCircle className="h-6 w-6 text-[#FF4C18]" />;
    }
  };

  const getBorderColor = () => {
    switch (type) {
      case "success":
        return "border-green-500";
      case "error":
        return "border-red-500";
      case "warning":
        return "border-yellow-500";
      default:
        return "border-[#FF4C18]";
    }
  };

  return (
    <div className="fixed top-4 right-4 z-[99999] animate-slide-in">
      <div
        className={`bg-white rounded-lg shadow-xl p-6 max-w-md w-full border-l-4 ${getBorderColor()}`}
      >
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0">{getIcon()}</div>
          <div className="flex-1">
            <p className="text-base font-semibold text-gray-900 mb-1">
              {type.charAt(0).toUpperCase() + type.slice(1)}
            </p>
            <p className="text-sm text-gray-600">{message}</p>
          </div>
          <div className="flex-shrink-0">
            <button
              onClick={onClose}
              className="inline-flex text-gray-400 hover:text-gray-500 focus:outline-none transition-colors"
            >
              <FaTimes className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Toast;
